import { WorkflowRunStepStatusEnum } from "@simbelapp/order-sdk";
import { ColorsTypeEnum } from "~/utils/enums/colores.enums";
import type { IWorkflowRunStepStatusTag } from "~/utils/interfaces/workflows-interfaces";

export enum TypeWorkflowPanelEnum {
  SETTING = "setting",
  ACTION = "action",
}

export enum TypeStepEnum {
  CONDITION_SELECTOR = "condition_selector",
  ACTION = "action",
  TRIGGER = "trigger",
  EMAIL = "email",
  UNSCHEDULE = "unschedule",
  CANCEL_USER_BOOKINGS = "cancel_user_bookings",
  CANCEL_USER_REQUESTS = "cancel_user_requests",
  DISABLE_HABILITATIONS_RENEWAL = "disable_habilitations_renewal",
  WAIT_UNTIL = "wait_until",
  EXTERNAL_TOOL = "external_tool",
  SESSION_CONFIRMED = "session_confirmed",
  SEND_SESSION_NOTIFICATION = "send_session_notification",
  SEND_NOTIFICATION_TO_ATTENDEE = "send_notification_to_attendee",
  SEND_NOTIFICATION_TO_MANAGER = "send_notification_to_manager",
  SEND_PARTNER_NOTIFICATION = "send_partner_notification",
  SEND_TRAINER_SIGNATURE_NOTIFICATION = "send_trainer_signature_notification",
  SUMMON_ATTENDEES = "summon_attendees",
  SUMMON_ONE_ATTENDEE = "summon_one_attendee",
  FILTER_ABSENCE_REASON = "filter_absence_reason",
}

export enum TypeRuleEnum {
  PERSONNALISATION = "personnalisation",
  SIMBEL = "simbel",
}

export enum TypeWorkflowActionEnum {
  ACTIVATE = "activate",
  DEACTIVATE = "deactivate",
  DELETE = "delete",
}

export enum TypeWorkflowStatusEnum {
  IN_PROGRESS = "in_progress",
  FINISHED = "finished",
  PENDING = "pending",
}

export enum AbsenceReasonOperatorEnum {
  EXCLUDE = "exclude",
  INCLUDE = "include",
}

export enum ArrayOperatorEnum {
  IN_ARRAY = "inArray",
  NOT_IN_ARRAY = "notInArray",
}

export enum AbsentReasonEnum {
  SICK_CHILD = "Enfant malade",
  PAID_LEAVE = "Congés payés",
  SCHEDULE_CHANGE = "Changement de planning",
  SICK = "Maladie",
  TRAINER_EXCLUSION = "Exclusion formateur",
  COMPANY_DEPARTURE = "Départ société",
  ORGANIZATION_CANCELLATION = "Annulation par l'organisme",
  HR_CANCELLATION = "Annulation par l'équipe RH",
  ABANDONMENT = "Abandon",
  UNJUSTIFIED = "Non justifié",
  OTHER = "Autre",
}

export enum WorkflowEventNameEnum {
  USER_DISABLED = "user_disabled",
  SESSION_CREATED = "session_created",
  NEW_NO_SHOW = "new_no_show",
  ATTENDEE_ADDED = "attendee_added",
  SCHEDULED_DAILY = "scheduled_daily",
}

export enum WorkflowFilterTypeEnum {
  TRAINING_PARTNER = "training_partner",
  LEGAL_ENTITY = "legal_entity",
  SITE = "site",
  FORMAT = "format",
}

/** Reasons orders records on a skipped run step (`metadata.reason`), matched to pick the French copy. */
export enum WorkflowRunStepSkipReasonEnum {
  NO_PARTNER_EMAIL = "No partner contact email on session",
}

export const WORKFLOW_RUN_STEP_SKIP_REASON_LABEL: Record<WorkflowRunStepSkipReasonEnum, string> = {
  [WorkflowRunStepSkipReasonEnum.NO_PARTNER_EMAIL]:
    "Aucun contact prestataire n'était renseigné sur la session au moment du déclenchement.",
};

/** Pill of an action run step: the colour carries its outcome. */
export const WORKFLOW_RUN_ACTION_STATUS_TAG: Record<WorkflowRunStepStatusEnum, IWorkflowRunStepStatusTag> = {
  [WorkflowRunStepStatusEnum.Pending]: { value: "En attente", type: ColorsTypeEnum.LIGHT_GREY },
  [WorkflowRunStepStatusEnum.InProgress]: { value: "En cours", type: ColorsTypeEnum.LIGHT_GREY },
  [WorkflowRunStepStatusEnum.Success]: { value: "Terminée", type: ColorsTypeEnum.LIGHT_GREEN },
  [WorkflowRunStepStatusEnum.Skipped]: { value: "Ignorée", type: ColorsTypeEnum.LIGHT_ORANGE },
  [WorkflowRunStepStatusEnum.Failed]: { value: "Échec", type: ColorsTypeEnum.LIGHT_RED },
  [WorkflowRunStepStatusEnum.Canceled]: { value: "Annulée", type: ColorsTypeEnum.LIGHT_GREY },
};

/** Pill of a condition run step: always grey, it only tells where the sequence stands. */
export const WORKFLOW_RUN_CONDITION_STATUS_TAG: Record<WorkflowRunStepStatusEnum, IWorkflowRunStepStatusTag> = {
  [WorkflowRunStepStatusEnum.Pending]: { value: "En attente", type: ColorsTypeEnum.LIGHT_GREY },
  [WorkflowRunStepStatusEnum.InProgress]: { value: "En attente", type: ColorsTypeEnum.LIGHT_GREY },
  [WorkflowRunStepStatusEnum.Success]: { value: "Passée", type: ColorsTypeEnum.GREY },
  [WorkflowRunStepStatusEnum.Skipped]: { value: "Ignorée", type: ColorsTypeEnum.GREY },
  [WorkflowRunStepStatusEnum.Failed]: { value: "Échec", type: ColorsTypeEnum.GREY },
  [WorkflowRunStepStatusEnum.Canceled]: { value: "Annulée", type: ColorsTypeEnum.LIGHT_GREY },
};
